import { createUploadLink } from 'apollo-upload-client'
import { setContext } from '@apollo/client/link/context'
import { ApolloLink, Observable } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'

import { getProcessinguuid } from '@/helpers/auth'
import { addPendingRequest, canExpire, isExpiredError, isRefreshExpiredError, refreshSession, resolvePendingRequests, state } from '@/providers/apollo/refresh'
import { redirectToExpired } from '@/plugins/logged-user/loggedUser'

function getAccount() {
  if (typeof window !== 'undefined' && window.localStorage.getItem('loggedUser')) {
    var account = JSON.parse(window.localStorage.getItem('loggedUser')).id_account
    return account ?? ''
  }
}

const operations = [
  'ListProduct',
  'ListMeasure',
  'BrandsGlobal',
  'Brands',
  'ListCategory',
  'SubCategories',
  'CreateProduct',
  'UploadFile',
  'FindProductById',
  'UpdateProduct',
  'ListDepartment',
  'UploadProducts',
  'StoreProducts',
  'StoreProductById',
  'UpdateStoreProduct',
  'CreateStoreProduct',
  'FindProduct',
  'CleanProductsDuplicates',
]

// Http endpoint
export const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://hulk.mercafacil.com/graphql'

export const getHttpLink = () => {
  const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    console.error(graphQLErrors)
    const isRefreshExpired = graphQLErrors?.some(isRefreshExpiredError)
    if (isRefreshExpired) {
      console.error(`isRefreshExpired:${isRefreshExpired}`)
      redirectToExpired()
      return
    }

    if (graphQLErrors?.some(isExpiredError)) {
      return new Observable((observer) => {
        const retryRequest = () => {
          operation.setContext(({ headers = {} }) => ({
            headers,
          }))

          forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          })
        }

        if (!state.isRefreshing) {
          console.log('!state.isRefreshing', !state.isRefreshing)
          state.isRefreshing = true
          refreshSession()
            .then(() => {
              console.log('refreshSession:then')
              resolvePendingRequests()
              retryRequest()
              state.isRefreshing = false
              console.log('refreshSession:then:end')
            })
            .catch((err) => {
              console.log('refreshSession:catch', err)
              console.log('refreshSession:catch:pend', state.pendingRequests.length)
              observer.error(err)
              console.log('refreshSession:catch:middle')
              resolvePendingRequests()
              state.isRefreshing = false
              if (canExpire(err)) redirectToExpired()
              console.log('refreshSession:catch:end')
            })
        } else {
          console.log('refreshSession:addPendingRequest')
          addPendingRequest((token) => retryRequest(token))
        }
      })
    }
  })

  const httpLink = createUploadLink({
    uri: httpEndpoint,
    fetchOptions: {
      credentials: 'include',
    },
  })
  let fingerprint

  // Auth middleware
  const authLink = setContext((request, { headers = {} } = {}) => {
    const localHeaders = {
      processinguuid: getProcessinguuid(),
    }

    if (operations.includes(request.operationName)) {
      localHeaders.accountid = getAccount()
    }

    return {
      headers: {
        ...localHeaders,
        ...headers,
      },
    }
  })

  // Fingerprint middleware
  const fingerprintLink = setContext(async (request, { headers = {} } = {}) => {
    if (!fingerprint) {
      const fingerprintLocalStorage = JSON.parse(window.localStorage.getItem('fingerprint'))
      fingerprint = fingerprintLocalStorage?.visitorId
    }
    return {
      headers: {
        fingerprint,
        ...headers,
      },
    }
  })

  return ApolloLink.from([errorLink, fingerprintLink, authLink, httpLink])
}
